<div class="new-model-dialog-body">
  <div class="cms-mode-modal">
    <form [formGroup]="cmsModeForm">
      <div class="col-12 title-class mt-3">
        <app-filed
          [style]="{ height: '54px !important' }"
          [length]="100"
          class="d-block"
          formControlName="titleEn"
          [control]="cmsModeForm | getControl : 'titleEn'"
          [title]="'shared.englishLabel' | translate"
          [placeholder]="'shared.englishLabel' | translate"
          [id]="'titleEn'"
          (onKeyup)="checkFormValid($event)"
        ></app-filed>
      </div>

      <div class="col-12 title-class mt-3">
        <app-filed
          [style]="{ height: '54px !important' }"
          [length]="100"
          class="d-block"
          formControlName="titleAr"
          [control]="cmsModeForm | getControl : 'titleAr'"
          [title]="'shared.arabicLabel' | translate"
          [placeholder]="'shared.arabicLabel' | translate"
          [id]="'titleAr'"
          (onKeyup)="checkFormValid($event)"
        ></app-filed>
      </div>
    </form>
  </div>
</div>
<div class="new-model-dialog-footer">
  <div class="col-12 action-buttons mt-3" buttons>
    <!-- cancel button -->
    <button class="btn btn-dark flex-grow-1" (click)="closeModal()">
      {{ "shared.back" | translate }}
    </button>
    <!--    <button (click)="setTranslationToObject()">test</button>-->
    <!-- send request button -->
    <button
      [disabled]="sendingLoading || !cmsModeForm.valid"
      class="btn btn-main flex-grow-1"
      (click)="saveFormData()"
    >
      <i *ngIf="sendingLoading" class="bx bx-loader-alt bx-spin ml-1"></i>
      {{ "shared.save" | translate }}
    </button>
  </div>
</div>
